import { combineReducers } from '@reduxjs/toolkit';
import jobsSlice from 'core/slices/jobSlice';
import scheduleListSlice from 'core/slices/schedules/scheduleListSlice';
import toastSlice from 'core/slices/toasts';

const rootReducer = combineReducers({
  jobs: jobsSlice.reducer,
  schedules: scheduleListSlice.reducer,
  toasts: toastSlice.reducer,
});
export default rootReducer;
